import api from "../../../utils/api";
const apiUrl = process.env.REACT_APP_MOCK_RESUME_URL;

export const getUserInfo = async(id, vendorRoute) => {
	try {
		return api.get(`/user/${vendorRoute ? "getvendorreport" : "getclientreport"}?id=${id}`);
	} catch (error) {
		console.warn(error);
		return error;
	}
}

 export const updateUserUsage = async ( id , data) => {
	try {
	  const response = await api.put(`/plans/usageUpdate/${id}`, data , { baseURL: apiUrl }); 
	  return response
	} catch (error) {
	  console.error('Error updating user usage:', error);
	  throw error;
	}
  };